export const DEFAULT_PAGE = '1'
export const DEFAULT_PAGE_SIZE = '10'
export const DEFAULT_PAGE_SIZE_DATA_REPORT = '25'
export const DEFAULT_PAGE_SIZE_BATCH = '25'
export const PAGE_SIZE_MAX = '200'
// Validation state colors
export const VALID_COLOR = '#14B8A6'
export const INVALID_COLOR = '#f1416c'

// Design system tokens (brand palette). DS_TEAL aliases VALID_COLOR — same brand teal.
export const DS_TEAL = VALID_COLOR
export const DS_TEAL_DARK = '#085E57'
export const DS_TEAL_LIGHT = '#F0FDFA'
export const DS_TEXT_MUTED = '#64748B'
export const DS_TEXT_DARK = '#1E2A3B'
export const DS_SEPARATOR = '#CBD4E1'
export const TABLE_KEY_COLUMN = {
  CAN_CHECK: 'canCheck',
  ACTIONS: 'actions',
  SUB_ACTIONS: 'sub-actions',
  DATE: 'date',
  SERVICE: 'service',
  SHIP_TO: 'ship_to',
  OUT_FOR_DELIVERY: 'out_for_delivery',
  SHIP_FROM: 'ship_from',
  PACKAGE_INFO: 'package_info',
  TRACKING_NUMBER: 'tracking_number',
  ADD_ON_SERVICES: 'add_on_services',
}
// Value must be unique
export const CUSTOM_COLUMN_NAME = {
  ORDER_PAGE: {
    ALL: 'ORDER_PAGE_ALL',
    OPEN: 'ORDER_PAGE_OPEN',
    SHIPPED: 'ORDER_PAGE_SHIPPED',
    ON_HOLD: 'ORDER_PAGE_ON_HOLD',
    CANCELLED: 'ORDER_PAGE_CANCELLED',
  },
  BATCHES_DETAIL_PAGE: {
    ALL: 'BATCHES_DETAIL_PAGE_ALL',
    OPEN: 'BATCHES_DETAIL_PAGE_OPEN',
    SHIPPED: 'BATCHES_DETAIL_PAGE_SHIPPED',
    ON_HOLD: 'BATCHES_DETAIL_PAGE_ON_HOLD',
    CANCELLED: 'BATCHES_DETAIL_PAGE_CANCELLED',
  },
  REPORT: {
    ENDING_BALANCES: 'REPORT_ENDING_BALANCES',
    REBATE: 'REPORT_REBATE',
    SHIPMENT: 'REPORT_SHIPMENT',
    SHIPMENTS_RETURN: 'SHIPMENTS_RETURN',
    TRANSACTIONS: 'REPORT_TRANSACTIONS',
    ORDER: 'REPORT_ORDER',
  },
  SHIPMENT_PAGE: 'SHIPMENT_PAGE',
  ORGANIZATION_PAGE: 'ORGANIZATION_PAGE',
}
export const DEFAULT_DATE_FILTER = {
  ORDERS: 29,
  SHIPMENTS: 6,
  BATCHES: 29,
  CLAIMS: 364,
}

export const CARRIERS = {
  FEDEX: 'fedex',
  USPS: 'usps',
  UPS: 'ups',
  DHL: 'dhl',
  CAINIAO: 'cainiao',
  ONTRAC: 'ontrac',
  HORIZON: 'horizon',
  AMAZON: 'amazon',
  UNIUNI: 'uniuni',
  GOFO: 'gofo',
}

export const SERVICES = {
  DHL_EXPRESS: 'dhl_express',
  UPS_MI: 'ups_mi_expedited',
  USPS_PRIORITY: 'usps_priority',
  USPS_PRIORITY_EXPRESS: 'usps_priority_express',
  USPS_GROUND_ADVANTAGE: 'usps_ground_advantage',
  USPS_FIRSTCLASS: 'usps_firstclass',
  USPS_MEDIA: 'usps_media',
  USPS_BOUND_PRINTED_MATTER: 'usps_bound_printed_matter',
  UPS_GROUND: 'ups_ground',
  UPS_GROUND_SAVER: 'ups_ground_saver',
  UPS_3DAY_SELECT: 'ups_3day_select',
  UPS_2DAY_AIR: 'ups_2day_air',
  UPS_2DAY_AIR_AM: 'ups_2day_air_am',
  UPS_NEXT_AIR: 'ups_next_air',
  UPS_NEXT_AIR_SAVER: 'ups_next_air_saver',
  DHLECOM_GROUND: 'dhlecom_ground',
  DHLECOM_EXPEDITED: 'dhlecom_expedited',
  FEDEX_GROUND: 'fedex_ground',
  FEDEX_HOME_DELIVERY: 'fedex_home_delivery',
  FEDEX_ECONOMY: 'fedex_economy',
  FEDEX_2DAY_ONERATE: 'fedex_2day_onerate',
  FEDEX_2DAY: 'fedex_2day',
  FEDEX_PRIORITY_OVERNIGHT: 'fedex_priority_overnight',
  FEDEX_STANDARD_OVERNIGHT: 'fedex_standard_overnight',
  FEDEX_INTERNATIONAL_ECONOMY: 'fedex_international_economy',
  FEDEX_INTERNATIONAL_PRIORITY: 'fedex_international_priority',
  CAINIAO_GROUND: 'cainiao_ground',
  ONTRAC_GROUND: 'ontrac_ground',
  HORIZON_GROUND: 'horizon_ground',
  AMAZON_GROUND: 'amazon_ground',
  UNIUNI_GROUND: 'uniuni_ground',
  GOFO_GROUND: 'gofo_ground',
}

export const USPS_MANIFEST_SERVICES = [
  SERVICES.USPS_PRIORITY,
  SERVICES.USPS_GROUND_ADVANTAGE,
  SERVICES.USPS_FIRSTCLASS,
  SERVICES.USPS_MEDIA,
  SERVICES.USPS_BOUND_PRINTED_MATTER,
  SERVICES.USPS_PRIORITY_EXPRESS,
]

export const FEDEX_INTERNATIONAL_SERVICES = [
  SERVICES.FEDEX_INTERNATIONAL_ECONOMY,
  SERVICES.FEDEX_INTERNATIONAL_PRIORITY,
]

export const ROUNDED_LOGO_CARRIERS = [SERVICES.DHL_EXPRESS, SERVICES.GOFO_GROUND]

export const HAZMAT_APPLICABLE_SERVICE = ['usps_priority', 'usps_ground_advantage']

export const FORMAT_DATE = {
  DATE_TIME: 'MM/DD/YYYY hh:mm A',
  DATE_TIME_24H: 'MM/DD/YYYY HH:mm',
  TIME_12: 'hh:mm A',
  DATE_TIME_FULL: 'MM/DD/YYYY hh:mm:ss A',
  DATE: 'MM/DD/YYYY',
  DATE_TIME_TIMEZONE_FULL: 'MM/DD/YYYY hh:mm:ss A Z',
  DATE_TIME_TIMEZONE_EXCLUDE_SECOND: 'MM/DD/YYYY hh:mm A Z',
  TIMEZONE: 'Z',
}

// Promos
export const MARKET_PROMO_AMOUNT = 50
export const TEMU_AMOUNT = 100
export const MARKET_PROMO_BANNER_VISIBLE_KEY = 'market_promo_banner_visible'
export const TEMU_BANNER_VISIBLE_KEY = 'temu_banner_visible'
export const BAEGUARD_BANNER_VISIBLE_KEY = 'baeguard_banner_visible'
export const BAEGUARD_SETING_AUTO_VISIBLE_KEY = 'baeguard_setting_auto_visible'

export const ACCEPT_TERM_UPIC_KEY = 'accept-term-upic'

// Tutorial Checklist
export const TUTORIAL_CHECKLIST_TOGGLE_ID = 'tutorial-checklist-toggle'
